export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-emerald-600">GreenState Investments</span>?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We're a nationwide real estate wholesaler dedicated to providing homeowners with fast, fair, and hassle-free solutions. Whether you're facing foreclosure, dealing with inherited property, or simply need to sell quickly, we're here to help.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20real%20estate%20team%20handshake%20with%20happy%20homeowners%20in%20modern%20bright%20office%20setting%20diverse%20business%20people%20celebrating%20successful%20property%20deal%20warm%20natural%20lighting%20clean%20professional%20atmosphere%20showing%20trust%20and%20partnership&width=800&height=600&seq=about-img-001&orientation=landscape"
              alt="GreenState Investments Team"
              className="w-full h-full object-cover rounded-lg shadow-xl"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              At GreenState Investments, we believe selling your home should be simple and stress-free. We eliminate the traditional hassles of listing with an agent, making repairs, or waiting months for a buyer. Our mission is to provide homeowners across America with a fast, transparent, and fair cash offer for their property.
            </p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              With years of experience in real estate wholesaling, we've helped thousands of homeowners sell their properties quickly and move forward with their lives. We buy houses in any condition, in any location, and close on your timeline.
            </p>
            <div className="flex items-start gap-4 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-2xl text-emerald-600"></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">No Repairs Needed</h4>
                <p className="text-gray-600 text-sm">We buy houses as-is, saving you time and money</p>
              </div>
            </div>
            <div className="flex items-start gap-4 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-2xl text-emerald-600"></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Close on Your Schedule</h4>
                <p className="text-gray-600 text-sm">Choose your closing date - as fast as 7 days</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-checkbox-circle-fill text-2xl text-emerald-600"></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Zero Fees or Commissions</h4>
                <p className="text-gray-600 text-sm">No hidden costs - you keep the full offer amount</p>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
              <i className="ri-home-smile-line text-3xl text-emerald-600"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Any Condition</h4>
            <p className="text-gray-600 text-sm">We buy houses in any condition, from pristine to distressed</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-3xl text-emerald-600"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Cash Offers</h4>
            <p className="text-gray-600 text-sm">Receive a fair all-cash offer with no financing contingencies</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
              <i className="ri-calendar-check-line text-3xl text-emerald-600"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Fast Closing</h4>
            <p className="text-gray-600 text-sm">Close in as little as 7 days or on your preferred timeline</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
              <i className="ri-user-heart-line text-3xl text-emerald-600"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Personal Service</h4>
            <p className="text-gray-600 text-sm">Dedicated support throughout the entire selling process</p>
          </div>
        </div>
      </div>
    </section>
  );
}